export default "__VITE_ASSET__NNVT47Of__"